import { handlerGetUrlParams } from '@/utils/dealUrlParams'
import request from '@/utils/request'

export function getTalentDataList(param) {
  const url = handlerGetUrlParams('/bus/talent/home/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 查看详细信息
export function checkTalentData(id) {
  return request({
    url: `/bus/talent/home/${id}`,
    method: 'GET'
  })
}

export function getTeamDataList(param) {
  const url = handlerGetUrlParams('/bus/team/list', param)
  return request({
    url,
    method: 'GET'
  })
}
